import { ClAIM_METHODS } from '@/common/constants/validClaims';
import { PROVIDER_MARKETS } from '../constants/paymentProvidersForCountries';

export const findCalimProvider = (claim) => {
	if (claim.payment_method === ClAIM_METHODS.CASH.value) {
		return ClAIM_METHODS.CASH.label;
	}

	const contactCountryCode = claim._contact.country?.toUpperCase() ?? '';

	for (const [provider, markets] of Object.entries(PROVIDER_MARKETS)) {
		if (markets.includes(contactCountryCode)) {
			return provider;
		}
	}

	return null;
};
